export type LeadConversionTrigger =
    | 'guest_card'
    | 'campaign_reply'
    | 'call'
    | 'pm_manual'

export interface ProspectsStepConfig {
    auto_enroll_email_campaign: boolean
    auto_enroll_phone_campaign: boolean
}

export type StepEnterBehavior = 'auto_start' | 'queue' | 'pm_start'

export type ApplicationHandbookScope = 'workbook_complete' | 'identity_complete'

export interface LeadsStepConfig {
    on_enter_automations: {
        send_account_invite?: { enabled: boolean; template_id?: string }
    }
    application_handbook?: {
        scope: ApplicationHandbookScope
    }
    /** @deprecated Use application_handbook.scope */
    portal_collection?: {
        qualifying_worksheet?: boolean
    }
    enter_behavior?: StepEnterBehavior
}

export interface WorkbookGateConfig {
    screening_start: 'identity_complete' | 'workbook_complete' | 'manual_only'
    before_sign: 'workbook_complete' | 'identity_complete'
    remainder_due: 'before_sign' | 'before_lease' | 'after_lease' | 'never'
    pm_override: {
        allow_skip_to_screening: boolean
        allow_advance_incomplete: boolean
        require_reason: boolean
    }
}

export interface ApplicationVariantConfig {
    id: string
    qualifying_method: string
    signable_doc_id?: number
    signable_doc_ref?: {
        doc_role: string
        template_key?: string
    }
}

export interface ApplicationStepConfig {
    mode?: 'qualify_first' | 'collect_first'
    workbook_gate?: WorkbookGateConfig
    fee_gate?: 'before_form' | 'before_sign' | 'after_signatures' | 'never'
    fee_amount?: number
    require_review_on_complete?: boolean
    applications?: ApplicationVariantConfig[]
}

export interface ScreeningStepConfig {
    reports?: Array<'credit' | 'background' | 'income'>
    data_source?: 'workbook' | 'application' | 'manual'
    required_phase?: 'identity_complete' | 'workbook_complete'
    scoring?: boolean
    instance_label?: string
}

export interface QualificationStepConfig {
    credit_score_min?: number
    income_ratio_min?: number
    qualifying_methods_enabled?: string[]
    applications?: ApplicationVariantConfig[]
}

export type StepConfigByType = {
    prospects: ProspectsStepConfig
    leads: LeadsStepConfig
    application: ApplicationStepConfig
    screening: ScreeningStepConfig
    qualification: QualificationStepConfig
}

export const LEAD_CONVERSION_TRIGGER_OPTIONS: {
    value: LeadConversionTrigger
    label: string
}[] = [
    { value: 'guest_card', label: 'Guest card submitted' },
    { value: 'campaign_reply', label: 'Campaign reply' },
    { value: 'call', label: 'Inbound call' },
    { value: 'pm_manual', label: 'PM manual conversion' },
]
